import type { DownloadSyncOp, SyncOperation } from '@mimir/client-common/upload/premiere';

export function makeSyncOperation(
  config: {
    isStandaloneMode: boolean,
    isProxyMode: boolean,
  },
  type: SyncOperation['type'],
): SyncOperation {
  if (type == 'highres' || type == 'proxy') {
    return makeDownloadOperation(config, type, false);
  }

  return { type };
}

export function makeDownloadOperation<DlType extends DownloadSyncOp['type']>(
  config: {
    isStandaloneMode: boolean,
    isProxyMode: boolean,
  },
  type: DlType,
  alsoDownloadHighres: boolean,
): DownloadSyncOp & { type: DlType } {
  return {
    type,
    alsoDownloadHighres,
    isPremiereStandaloneMode: config.isStandaloneMode,
    isProxyWorkflowEnabled: config.isProxyMode,
  };
}
